import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import RefreshIcon from '@mui/icons-material/Refresh';
import ViewListIcon from '@mui/icons-material/ViewList';

export type ResourceViewMode = 'row' | 'map';

interface ToggleProps {
  active: boolean;
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}

const ToggleIconButton = ({ active, title, onClick, children }: ToggleProps) => (
  <Tooltip title={title}>
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        borderRadius: 0,
        width: 34,
        height: 34,
        border: '0.5px solid',
        borderColor: active ? 'primary.main' : 'divider',
        color: active ? 'primary.main' : 'text.secondary',
        bgcolor: active ? 'primary.light' : 'transparent',
      }}
    >
      {children}
    </IconButton>
  </Tooltip>
);

export const ResourceViewControls = ({
  mode,
  onModeChange,
  onRefresh,
}: {
  mode: ResourceViewMode;
  onModeChange: (mode: ResourceViewMode) => void;
  onRefresh: () => void;
}) => (
  <>
    <ToggleIconButton active={mode === 'row'} title="Row view" onClick={() => onModeChange('row')}>
      <ViewListIcon fontSize="small" />
    </ToggleIconButton>
    <ToggleIconButton active={mode === 'map'} title="Map view" onClick={() => onModeChange('map')}>
      <MapIcon fontSize="small" />
    </ToggleIconButton>
    <Tooltip title="Refresh">
      <IconButton
        size="small"
        onClick={onRefresh}
        sx={{ borderRadius: 0, width: 34, height: 34, border: '0.5px solid', borderColor: 'divider' }}
      >
        <RefreshIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </>
);
